import LightbulbWithRaysIconPath from "@ingka/ssr-icon/paths/lightbulb-with-rays";

export default LightbulbWithRaysIconPath;
